module.exports = __webpack_public_path__ + "img/progress-bar.3cdbba05.gif";